module.exports = __webpack_public_path__ + "static/media/messenger.86065778.png";